































import {
  computed, defineComponent, PropType, ref,
} from '@nuxtjs/composition-api';

import { RatingsInterface } from '~/composables';

import { RatingStar } from './types';

export default defineComponent({
  name: 'RatingBars',
  props: {
    ratings: {
      type: Object as PropType<RatingsInterface>,
      required: true,
    },
    filterEnable: {
      type: Boolean,
    },
  },

  emits: ['filter-reviews'],

  setup(props, { emit }) {
    const showSeeAll = ref<boolean>(false);
    const ratingStars = computed<RatingStar[]>(() => Object.keys(props.ratings.stars).reverse().map((key) => ({
      value: key,
      ...props.ratings.stars[key],
    })));

    const filterReviews = (rating: RatingStar): void => {
      if (props.filterEnable && rating.count > 0) {
        emit('filter-reviews', `${+rating.value + 1}`);
        showSeeAll.value = true;
      }
    };

    const resetFilter = () => {
      showSeeAll.value = false;
      emit('filter-reviews');
    };

    return {
      showSeeAll,
      ratingStars,
      filterReviews,
      resetFilter,
    };
  },
});
